export enum PurchaseSource {
  AllDayMarket = 'AllDayMarket',
  AfterSchoolMarket = 'AfterSchoolMarket',
  SeasonalMarket = 'SeasonalMarket',
  InGameBoostMenu = 'InGameBoostMenu',
  ArcadeGameSpend = 'ArcadeGameSpend'
}
